export const listSubscriptions = `
   query listSubscriptions($filter: SubscriptionsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listSubscriptions(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              customerId
              customer {
                id
                name
              }
              items {
                items {
                  id
                  subscriptionId
                  priceId
                  price {
                    product {
                        name
                    }
                    amount
                    billingPeriod
                  }
                  quantity
                }
                nextToken
              }
              status
              created
              createdByUsername
              updated
           }
           nextToken
       }
   }
`;

export const getSubscription = `
   query getSubscription($id:ID!) {
       getSubscription(id:$id) {
         id
         customerId
         customer {
            id
            name
         }
         items {
           items {
             id
             subscriptionId
             priceId
             price {
               product {
                   name
               }
               amount
               billingPeriod
             }
             quantity
           }
           nextToken
         }
         status
         created
         createdByUsername
         createdByUser {
           name
           givenName
           familyName
           email
         }
         updated
         updatedByUsername
       } 
}`;
